<script>
  import {
    page
  } from '@inertiajs/svelte'

  import Header from "../layouts/_header.svelte"
  import Footer from "../layouts/_footer.svelte"
  import Flash from "../components/_flash.svelte"

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  let { RailsApp } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale
</script>

<Flash {...$page.props} />

<Header {...$page.props} />
<div class="{RailsApp.Request.controller} {RailsApp.Request.action} layouts main">
  <div id="body">
    <slot />
  </div>
</div>
<Footer {...$page.props} />
